export default {
  推荐好友加入: `推薦好友加入`,
  赢取巴塞罗那VIP之旅:'贏取巴塞隆納 <span class="vipWord">VIP</span>之旅',
  成为EBC推荐官: "現在正是推薦好友加入EBC金融集團的最佳時機，讓他們體驗更優質的交易方式。",
  立即参与: "立即推薦",
  专属奖励等你拿: "專屬獎勵等你拿",
  您将获得以下奖励:'2025年5月23日前成功推薦66位好友，獲得以下獎勵',
  西班牙巴塞罗那之旅:'西班牙巴塞隆納之旅',
  巴塞罗那足球俱乐部主场比赛VIP门票:'巴塞隆納足球俱樂部主場比賽VIP門票',
  巴塞罗那足球俱乐部专属晚宴:'巴塞隆納足球俱樂部專屬晚宴',
  往返机票酒店住宿当地接送导服务:'往返機票、酒店住宿當地接送導服務',
  如何赢取大奖:'如何贏取大獎？',
  登录EBC用户中心: "登錄EBC用戶中心",
  "进入“大赛推荐官”活动页面": "進入“大賽推薦官”活動頁面",
  生成您的邀请链接或二维码: "生成您的邀請鏈接或二維碼",
  成功推荐66人: "成功推薦66人",
  成功推荐奖励:'成功推薦的好友需在活動期間至少入金 $500 美元，並完成至少一筆交易',
  你还在等什么:'你還在等什麼？',
  EBC为交易者捉供更低点差:'「EBC 為交易者提供更低點差、具競爭力的返佣保障及多項專項福利。我們也希望在巴塞隆納與『你』見面！」',

  每一次推荐: "每一次推薦，都是叩開巴塞大門的黃金助攻",
  参与规则: "參與規則：",
  成为EBC推荐官并邀请66人: "成為EBC推薦官並邀請66人； ",
  所有被邀请人均入金大于等于$500: `所有被邀請人均入金大於等於$500，<br class="mobile" />且完成交易。`,
  参与方法: "參與方法",
  立即推荐: "立即推薦，以好友的助力，向傳奇致敬。",
  巴萨荣耀之旅: "巴塞榮耀之旅",
  每笔订单都是攻守博弈的艺术: ` 每筆訂單都是攻守博弈的藝術，<br class="mobile" />每個決策都將締造資本市場的史詩級射門。`,
  活动时间: "活動時間：",
  "2025年2月22日": "2025年2月22日 01:00:00（MT4/MT5時間）至2025年5月23日23:59:59（MT4/MT5時間）",
  活动规则: "活動規則：",
  ruleList: [
    "該活動與正常推薦獎勵和其他活動不存在衝突。",
    "被推薦人需完成入金並交易，第三方轉帳無效。",
    "推薦獎勵適用於合規交易者，EBC有權對違規行爲取消獎勵資格。",
    "通過邀請活動註冊的帳戶不允許轉移代理。",
    "獲獎以帳號有效激活為準，VIP觀賽席位含機票和住宿。",
    "本活動最終解釋權歸EBC金融集團所有。",
  ],
};
